<script setup lang="ts">
</script>

<template>
  <div class="flex min-h-svh flex-col items-center justify-center px-4 py-16 text-center">
    <span class="flex size-20 items-center justify-center rounded-full bg-warning/10 ring-8 ring-warning/5">
      <UIcon
        name="i-lucide-lock"
        class="size-9 text-warning"
      />
    </span>
    <h1 class="mt-7 text-2xl font-bold text-highlighted">
      Нет доступа
    </h1>
    <p class="mt-2 max-w-sm text-base leading-relaxed text-toned text-balance">
      У этой учётной записи нет прав на раздел, который ты открыл.
    </p>
    <UButton
      to="/"
      size="lg"
      color="primary"
      icon="i-lucide-house"
      label="На главную"
      class="mt-8"
    />
  </div>
</template>
